import { render } from "./TravellerView.vue?vue&type=template&id=6a6ed8de&scoped=true"
import script from "./TravellerView.vue?vue&type=script&lang=js"
export * from "./TravellerView.vue?vue&type=script&lang=js"

import "./TravellerView.vue?vue&type=style&index=0&id=6a6ed8de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6ed8de"]])

export default __exports__